'use client'

import styled from 'styled-components'

export const Label = styled.label``
